import TipsItem from './TipsItem';

export default TipsItem;
